<template>

    <!-- 加载状态 -->
    <el-empty v-if="isLoading" description="加载中...">
      <el-icon class="is-loading"><loading /></el-icon>
    </el-empty>
    <!-- 无数据状态 -->
    <el-empty v-else-if="articles.length === 0" description="暂无文章">
      <el-icon><document /></el-icon>
    </el-empty>
    <!-- 文章列表 -->
    <el-row :gutter="20" v-else>
      <el-col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="8"
        :xl="8"
        v-for="article in articles"
        :key="article.ID"
      >
        <el-card shadow="hover" class="article-item">
          <!-- 文章标题（卡片头部） -->
          <template #header>
            <a
              :href="article.TopicID
                ? `https://apppage.longhuvip.com/w383/share/PContent2.html?AID=${article.TopicID};${article.IsShowStyle};${article.IsEditContent}`
                : `/article_detail?MsgID=${article.ID}`"
              target="_blank"
            >
              <h2>{{ article.Title }}</h2>
            </a>
          </template>
          <!-- 文章摘要 -->
          <p class="summary">{{ article.ZhaiYao }}</p>
          <!-- 元信息 -->
          <div class="meta">
            <span class="create-time">{{ formatCreateTime(article.CreateTime) }}</span>
            <span
              class="type"
              :style="{ color: getTypeColor(article.Type) }"
            >
              {{ getTypeLabel(article.Type) }}
            </span>
          </div>
          <!-- 图片列表 -->
          <div class="images" v-if="article.img?.List?.length">
            <a :href="`/article_detail?MsgID=${article.ID}`" target="_blank">
              <img
                v-for="(img, index) in article.img.List"
                :key="index"
                :src="img"
                alt="Article Image"
              />
            </a>
          </div>
          <!-- 点赞信息 -->
          <div class="like">
            <span>点赞: {{ article.Like }}</span>
          </div>
        </el-card>
      </el-col>
    </el-row>

</template>

<script>
import axios from 'axios';
import { Loading, Document } from '@element-plus/icons-vue';

export default {
  components: {
    Loading,
    Document,
  },
  data() {
    return {
      articles: [],
      isLoading: true,
    };
  },
  methods: {
    // 文章列表获取
    async fetchArticles() {
      try {
        const response = await axios.get('/api/article_list');
        if (response.data.MsgTop?.List) {
          this.articles = response.data.MsgTop.List;
        }
      } catch (error) {
        console.error('获取文章列表失败', error);
      } finally {
        this.isLoading = false;
      }
    },
    // 时间格式化
    formatCreateTime(timestamp) {
      const date = new Date(parseInt(timestamp) * 1000);
      return date.toLocaleString();
    },
    // 类型颜色映射
    getTypeColor(type) {
      switch (type) {
        case '2': return 'blue';
        case '5': return 'green';
        case '9': return 'orange';
        case '13': return 'purple';
        default: return 'gray';
      }
    },
    // 类型标签映射
    getTypeLabel(type) {
      switch (type) {
        case '2': return '新闻';
        case '5': return '公告';
        case '9': return '复盘';
        case '13': return '专题';
        default: return '其他';
      }
    }
  },
  mounted() {
    this.fetchArticles();
  }
};
</script>

<style scoped>
.article-list {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.article-item {
  margin-bottom: 20px;
}

.article-item h2 {
  margin-top: 0;
  color: #333;
}

.summary {
  color: #555;
  margin-bottom: 10px;
}

.meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.create-time {
  color: #888;
  font-size: 0.9em;
}

.type {
  font-weight: bold;
}

.images {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.images img {
  max-width: 100%;
  height: auto;
  margin: 0 10px 10px 0;
  border-radius: 4px;
}

.like {
  color: #888;
  font-size: 0.9em;
}

.is-loading {
  font-size: 24px;
  margin-right: 16px;
}

.el-empty {
  margin-top: 50px;
}
</style>
